<header class="n-header" [class.scrolled]="isScrolled()">
  <nav class="n-nav">
    <div class="n-logo">
      <object data="assets/icons/nomoh_logo.svg" type="image/svg+xml"></object>
    </div>

    <ul class="n-nav-menu">
      <li><a class="n-nav-link" (click)="scrollToSection('home')">{{ "CABECALHO_PORTAL.INICIO" | translate }}</a></li>
      <li><a class="n-nav-link" (click)="scrollToSection('about')">Sobre</a></li>
      <li><a class="n-nav-link" (click)="scrollToSection('products')">{{ "CABECALHO_PORTAL.SOLUCOES" | translate }}</a></li>
      <li><a class="n-nav-link" (click)="scrollToSection('team')">Equipe</a></li>
      <li><a class="n-nav-link" (click)="scrollToSection('cases')">Cases</a></li>
      <li><a class="n-nav-link" (click)="navigateToWhatsApp()">{{ "CABECALHO_PORTAL.CONTATO" | translate }}</a></li>
    </ul>

    @if(logado()){
      <button class="n-cta-nav" routerLink="/selecao-sistemas">{{ "BOTAO.PERFIL" | translate }}</button>
    }@else {
      <button class="n-cta-nav" routerLink="/login">{{ "BOTAO.ENTRAR" | translate }}</button>
    }

  </nav>
</header>
